import { Controller } from "@hotwired/stimulus"

// Syncs the browser URL when a Turbo Frame navigates, without triggering a full page visit.
// On back/forward, forces a Turbo visit to properly restore the page.
//
// Usage:
//   <%= turbo_frame_tag "my_table", data: { controller: "ui--url-sync" } do %>
//     ...
//   <% end %>

if (!window.__urlSyncPopstateRegistered) {
  window.__urlSyncPopstateRegistered = true
  window.addEventListener("popstate", (event) => {
    if (event.state?.turboFrameSync) {
      window.Turbo.visit(window.location.href, { action: "replace" })
    }
  })
}

export default class extends Controller {
  connect() {
    this.handler = this.syncUrl.bind(this)
    this.element.addEventListener("turbo:frame-load", this.handler)

    if (!history.state?.turboFrameSync) {
      history.replaceState({ turboFrameSync: true }, "")
    }
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this.handler)
  }

  syncUrl() {
    const src = this.element.getAttribute("src")
    if (src) {
      const url = new URL(src, window.location.origin)
      history.pushState({ turboFrameSync: true }, "", url.pathname + url.search)
    }
  }
}
